import { render } from "./FridgeDetailsConfirmCoolingAssistSettingDialog.vue?vue&type=template&id=48f4ebf0&scoped=true&ts=true"
import script from "./FridgeDetailsConfirmCoolingAssistSettingDialog.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsConfirmCoolingAssistSettingDialog.vue?vue&type=script&lang=ts"

import "./FridgeDetailsConfirmCoolingAssistSettingDialog.vue?vue&type=style&index=0&id=48f4ebf0&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f4ebf0"]])

export default __exports__